import api from '@/services/api/adminApprovalRequest.js'
import { immerable } from 'immer'
import { useState } from 'react'

class ApprovalRequest {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.type = params.type
		this.status = params.status
		this.dateRequested = params.dateRequested
		this.organization = params.organization
		this.orgId = params.orgId
		this.persona = params.persona
		this.useCase = params.useCase
		this.user = params.user
		this.persona = params.persona
		this.organizationId = params.organizationId
		this.modifiedBy = params.modifiedBy
		this.comment = params.comment
		this.modified = params.modified
	}
}

const usePersonaApprovalRequest = (queryParam) => {
	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function findOne(parameter) {
		setLoading(true)

		const params = parameter || ''

		const [error, data] = await api.findOne(
			params.requestId
		)

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (parameter.requestId !== data.id) {
			return setError('Approval Request API has error')
		}

		const serializedData = serialize(data)
		const newItem = new ApprovalRequest(serializedData)

		return setCurrentItem(newItem)
	}

	function serialize(entry) {
		return {
			id: entry.id,
			type: entry.type,
			status: entry.status,
			dateRequested: entry.created,
			organization: entry.organization,
			orgId: entry.orgId,
			useCase: entry.useCase,
			user: entry.user,
			persona: entry.orgPersona,
			organizationId: entry.orgId,
			modifiedBy: entry.modifiedBy,
			comment: entry.comment,
			modified: entry.modified,
		}
	}

	return {
		error,
		loading,
		findOne,
		currentItem,
		setCurrentItem
	}
}

export default usePersonaApprovalRequest
